import React from 'react';
import { Typography } from '@mui/material';

// Extracted from the previously duplicated `SectionTitle` in NumericQuestionCard
// and BooleanQuestionCard. The two cards used different bottom margins (numeric:
// 1.5, boolean: 2), so `mb` is a prop to preserve each card's original spacing.
const QuestionCardSectionTitle: React.FC<{ children: React.ReactNode; mb?: number }> = ({ children, mb }) => (
    <Typography variant="body2" color="text.secondary" sx={{ mb, fontWeight: 600 }}>
        {children}
    </Typography>
);

export default QuestionCardSectionTitle;
